import React, { useEffect } from 'react';
import '../App.css';

/**
 * Themed confirm dialog (replaces window.confirm). Does not use browser chrome.
 */
export default function ConfirmModal({
  isOpen,
  onCancel,
  onConfirm,
  title = 'Confirm',
  message,
  confirmLabel = 'Confirm',
  cancelLabel = 'Cancel',
  danger = false
}) {
  useEffect(() => {
    if (!isOpen) return;
    const esc = (e) => e.key === 'Escape' && onCancel?.();
    document.addEventListener('keydown', esc);
    document.body.style.overflow = 'hidden';
    return () => {
      document.removeEventListener('keydown', esc);
      document.body.style.overflow = '';
    };
  }, [isOpen, onCancel]);

  if (!isOpen) return null;

  return (
    <div
      className="modal-overlay"
      onClick={(e) => e.target === e.currentTarget && onCancel?.()}
      role="alertdialog"
      aria-modal="true"
      aria-labelledby="confirm-modal-title"
      aria-describedby="confirm-modal-desc"
    >
      <div className="modal-panel confirm-modal-panel" style={{ maxWidth: '440px' }}>
        <div className="modal-header">
          <h2 id="confirm-modal-title" className="modal-title">
            {title}
          </h2>
          <button type="button" className="modal-close" onClick={onCancel} aria-label="Close">
            ×
          </button>
        </div>
        <div className="modal-body">
          <p id="confirm-modal-desc" style={{ margin: 0, color: 'var(--text-secondary)', lineHeight: 1.55 }}>
            {message}
          </p>
          <div
            style={{
              display: 'flex',
              gap: '12px',
              justifyContent: 'flex-end',
              flexWrap: 'wrap',
              marginTop: '24px'
            }}
          >
            <button type="button" className="btn btn-outline" onClick={onCancel}>
              {cancelLabel}
            </button>
            <button
              type="button"
              className={`btn ${danger ? 'btn-secondary' : 'btn-primary'}`}
              onClick={onConfirm}
              style={
                danger
                  ? { borderColor: 'rgba(244, 63, 94, 0.6)', color: 'rgb(251, 113, 133)' }
                  : undefined
              }
            >
              {confirmLabel}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
